"use strict";

module.exports = /*@ngInject*/function () {
  return function (input) {
    return encodeURIComponent(input);
  };
};